import type { FeatureMetadata } from "../feature.types";

import { AskTrovixFeature } from "./askTrovix/askTrovix.feature";
import { AskTrovixSettingsFeature } from "./askTrovixSettings/askTrovixSettings.feature";

export const AI_FEATURES = [
  AskTrovixFeature,
  AskTrovixSettingsFeature,
] as const satisfies readonly FeatureMetadata[];
